import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteSupplierModal = ({ supplierName, open, onClose, onConfirm }) => {
  
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle><span className="roboto-regular">{t('delete_supplier')}</span></DialogTitle>
      <DialogContent>
        <Typography><span className="roboto-light">{t('delete_supplier_confirmation', { supplierName })}</span></Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={onConfirm} variant="contained" color="error">{t('delete')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSupplierModal;